function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.164 3.297a1.02 1.02 0 00-.118.131l-6.925 9.195-2.619-3.375C4.162 8.795 3.49 8.684 3 9a.986.986 0 00-.234 1.444l3.023 3.912c.515.683 1.528.849 2.263.372a1.57 1.57 0 00.401-.372l7.33-9.732a.986.986 0 00-.093-1.335 1.14 1.14 0 00-1.526.008z",
  fill: "#596168"
});

var SvgCheck = function SvgCheck(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _ref);
};

export default SvgCheck;